import React from 'react';
import './Spinner.scss';

export default (props) => (<div style={props.style} className={'spinner__Loader ' + props.className} />);



// WEBPACK FOOTER //
// ./src/components/Spinner/index.js